import { action } from 'typesafe-actions';
import { AppControllersTypes } from './types';

export const authenticationStepRequest = () =>
  action(AppControllersTypes.AUTHENTICATION_STEP, {});

export const selectEmail = (emailSelected: number) =>
  action(AppControllersTypes.SELECT_EMAIL, { emailSelected });
